import { render, staticRenderFns } from "./SaleClientQuestionnaire.vue?vue&type=template&id=6c20cba7&"
import script from "./SaleClientQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./SaleClientQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports